/**
 * ч.1035: переходи з віджетів боргів головної у звіти — обидва кінці
 * контракту в одному місці: тут будуються посилання і тут же читаються
 * параметри на сторінках-адресатах. Розійтись не можуть.
 *
 *  • «усі →» → «Монітор розрахунків», вкладка «Загалом», список формується
 *    одразу (без окремого «сформувати»), «лише борги» увімкнено.
 *  • «прострочено за накладними» → «Розрахунки за документами» з тією ж
 *    стороною (покупці / постачальники).
 *  • організація з фільтра шапки передається, якщо обрана; «усі
 *    організації» шапки → сторінка лишає свою (звіти односторінкові по
 *    одній організації).
 * Параметри — одноразові: сторінка читає їх при відкритті і прибирає з
 * адреси, щоб оновлення сторінки не перезаписувало вибір користувача.
 */
export type DebtKind = 'receivable' | 'payable';

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** organization_id з адреси — лише схожий на UUID (сміття у профіль не пишемо). */
export function orgParam(p: URLSearchParams): string | undefined {
  const v = p.get('organization_id') ?? '';
  return UUID_RE.test(v) ? v : undefined;
}

const LANDING_KEYS = ['side', 'organization_id', 'form', 'only_debts'];
export function hasLanding(p: URLSearchParams): boolean {
  return LANDING_KEYS.some((k) => p.has(k));
}

export function debtReportLinks(kind: DebtKind, orgId?: string): { all: string; overdue: string } {
  const org = orgId ? `&organization_id=${encodeURIComponent(orgId)}` : '';
  return {
    all: `/reports/reconciliation-act?form=1&only_debts=1${org}`,
    overdue: `/reports/settlements-by-documents?side=${kind}${org}`,
  };
}

export function settlementsLanding(p: URLSearchParams): { side?: DebtKind; organization_id?: string } {
  const s = p.get('side');
  return {
    side: s === 'receivable' || s === 'payable' ? s : undefined,
    organization_id: orgParam(p),
  };
}

export function reconLanding(p: URLSearchParams): {
  form: boolean; onlyDebts: boolean; organization_id?: string;
} {
  return {
    form: p.get('form') === '1',
    onlyDebts: p.get('only_debts') === '1',
    organization_id: orgParam(p),
  };
}
